var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DreamForm',{attrs:{"dream":_vm.dream,"title":"New Dream","saveCallback":_vm.save,"cancelCallback":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }